// extracted by mini-css-extract-plugin
export default {"infoBoxContainer":"tBCCGpNYNQzGs78SNJPGv"};